/** 
 * Date:27-07-2023 Name:veerareddy   Code: VR1 Desc: store the patient list 
 * Date:05/09/2023 Name:Yasmeen      Code:y1   Desc: getting loginData
 */

import { Injectable, signal, WritableSignal } from '@angular/core';
import { DashboardgetProcedures } from '@core/models/dashboardget-procedures';
import { ClinicalTrial } from '@core/models/er-patient/clinical-trial';
import { FrequentlyUsedFlowsheet } from '@core/models/flowsheet/frequently-used-flowsheet.model';
import { DashboardMenuDropdown } from '@core/models/menu-role/dashboard-menu.model';


import { Proceduresresources } from '@core/models/proceduresresources';
import { RosTemplate } from '@core/models/ros/ros-template';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalDataSourceService {

  notificationNavigation:WritableSignal<{orderName:string, eSigned:boolean, trnOrderSetItemId?: number}> = signal<{orderName:string, eSigned:boolean, trnOrderSetItemId: number}>(null)

isUpdatedMedications:WritableSignal<boolean> = signal<boolean>(false)

dashboardMenus:WritableSignal<DashboardMenuDropdown[]> = signal<any>(null)
dashboardMenusSub = new BehaviorSubject<DashboardMenuDropdown[]>(null)
dashboardMenusSub$ = this.dashboardMenusSub.asObservable();

    //active-inactive count status
  private clinicStatusSubject = new Subject<any>();
  clinicStatus$ = this.clinicStatusSubject.asObservable();
  emitClinicStatusChanged(data) {
    this.clinicStatusSubject.next(data);
  }
get getUpdatedMedication(){
return this.isUpdatedMedications();
}

set setUpdatedMedication(isUpdated:boolean){
this.isUpdatedMedications.set(isUpdated)
}

  isLocationChangedSig = signal<boolean>(false);
  get isLocationChanged() {
    return this.isLocationChangedSig();
  }
  set setLocationChanged(isLocationChanged: boolean) {
    this.isLocationChangedSig.set(isLocationChanged);
  }

  xmlFile = signal<Blob>(null);
  set setXmlFile(file: Blob) {
    this.xmlFile.set(file);
  }

  storeSaveAndNextMedications(medications: any[]): void {
    localStorage.setItem("save-and-next_medication", JSON.stringify(medications));
  }
  removeSaveAndNextMedications(): void {
    localStorage.removeItem('save-and-next_medication');
  }
  getSaveAndNextMedications(): any[] {
    let medicationData = null;
    const medicationDataInStr = localStorage.getItem('save-and-next_medication');
    if (medicationDataInStr) {
      medicationData = JSON.parse(medicationDataInStr);
    }
    return medicationData;
  }

  private dataSource = new BehaviorSubject<any>(null);
  data = this.dataSource.asObservable();
  private gridselectionSource = new BehaviorSubject<any>(null);
  gridSelection$ = this.gridselectionSource.asObservable();

  private pdfAudioDoc = new BehaviorSubject<any>(false);
  pdfAudioDoc$ = this.pdfAudioDoc.asObservable();

  private medicationData = new BehaviorSubject<any>(null);
  medicationData$ = this.medicationData.asObservable();

  private storeCheckboxRadioAlign = new BehaviorSubject<any>('Horizontal');
  storeCheckboxRadioAlign$ = this.storeCheckboxRadioAlign.asObservable();

  private chatGroupUserData = new BehaviorSubject<any>(false);
  chatGroupUserData$ = this.chatGroupUserData.asObservable();

  private allergiesData = new BehaviorSubject<any>(false);
  allergiesData$ = this.allergiesData.asObservable();

  private vitalsUnitsStatus = new BehaviorSubject<any>(false);
  vitalsUnitsStatus$ = this.vitalsUnitsStatus.asObservable();

  private problemsData = new BehaviorSubject<any>(null);
  problemsData$ = this.problemsData.asObservable();

  private allergiesLength = new BehaviorSubject<any>({});
  allergiesLength$ = this.allergiesLength.asObservable();

  private medicationsLength = new BehaviorSubject<any>({});
  medicationsLength$ = this.medicationsLength.asObservable();

  private problemsLength = new BehaviorSubject<any>({});
  problemsLength$ = this.problemsLength.asObservable();

  private monthValid = new BehaviorSubject<any>({});
  monthValid$ = this.monthValid.asObservable();
  
  private yearValid = new BehaviorSubject<any>({});
  yearValid$ = this.yearValid.asObservable();

  private isExpiredMed = new BehaviorSubject<any>({});
  isExpiredMed$ = this.isExpiredMed.asObservable();

  private logOutSettingsData = new BehaviorSubject<any>({});
  logOutSettingsData$ = this.logOutSettingsData.asObservable();

  private clearReconciled = new BehaviorSubject<any>({});
  clearReconciled$ = this.clearReconciled.asObservable();

  private clearReconciledProblems = new BehaviorSubject<any>({});
  clearReconciledProblems$ = this.clearReconciledProblems.asObservable();

  private clearReconciledAllergies = new BehaviorSubject<any>({});
  clearReconciledAllergies$ = this.clearReconciledAllergies.asObservable();

  private deleteData = new BehaviorSubject<any>(null);
  deleteData$ = this.deleteData.asObservable();
  private deleteDataArray = new BehaviorSubject<any>([]);
  deleteDataArray$ = this.deleteDataArray.asObservable();

  private selectedPatient = new BehaviorSubject<any>(null);
  selectedPatient$ = this.selectedPatient.asObservable();

  private editdataSource = new BehaviorSubject<any>(null);
  editdata = this.editdataSource.asObservable();
  private deletedataSource = new BehaviorSubject<any>(null);
  deletedata = this.deletedataSource.asObservable();
  private addOrdersetItem = new BehaviorSubject<any>(null);
  addOrdersetItem$ = this.addOrdersetItem.asObservable();

  updateErDRowDataSource=new BehaviorSubject<any>(null);
  updateErDRowData$ = this.updateErDRowDataSource.asObservable();


  private procedureDeletedataSource = new BehaviorSubject<any>(DashboardgetProcedures);
  procedureDeletedata = this.procedureDeletedataSource.asObservable();

  private procedureeditdataSource = new BehaviorSubject<any>(DashboardgetProcedures);
  procedureeditdata = this.procedureeditdataSource.asObservable();

  private editClinicalTrialdataSource = new BehaviorSubject<any>(ClinicalTrial);
  editClinicalTrialdata = this.editClinicalTrialdataSource.asObservable();

  private editProceduredataSource = new BehaviorSubject<any>(Proceduresresources);
  editProceduredata = this.editProceduredataSource.asObservable();
  private addProceduredataSource = new BehaviorSubject<any>(Proceduresresources);
  addProceduredata = this.addProceduredataSource.asObservable();
  
  private templateEditStatus = new BehaviorSubject<any>(true);
  templateEditStatus$ = this.templateEditStatus.asObservable();

  private fontSizeBehaviour: BehaviorSubject<string> = new BehaviorSubject<string>('');
  fontSizeBehaviour$ = this.fontSizeBehaviour.asObservable();

  private draftSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  draft$=this.draftSource.asObservable();

  private erDashboardPatientDataStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  erDashboardPatientDataStatus$ = this.erDashboardPatientDataStatus.asObservable();
  // private getdataSource = new BehaviorSubject<any>(PatientWorkFlowMenu);
  // getPatientSidenavData = this.getdataSource.asObservable();
private viewPhysicalResource=new BehaviorSubject<any>(false);
viewPhysicalResource$=this.viewPhysicalResource.asObservable();

  private viewstaffUpdate = new BehaviorSubject<any>(false);
  viewstaffUpdate$ = this.viewstaffUpdate.asObservable();
  private navigateToOther = new BehaviorSubject<any>(false);
  navigateToOther$ = this.navigateToOther.asObservable();

  private templateIdState = new BehaviorSubject<any>(null);
  templateIdState$ = this.templateIdState.asObservable();

  private viewphysicanUpdate = new BehaviorSubject<any>(false);
  viewphysicanUpdate$ = this.viewphysicanUpdate.asObservable();

  
  private viewlocationUpdate = new BehaviorSubject<any>(false);
  viewlocationUpdate$ = this.viewlocationUpdate.asObservable();


  private phePatientTemplateDraft = new BehaviorSubject<RosTemplate[]>(null);
  phePatientTemplateDraft$ = this.phePatientTemplateDraft.asObservable();
  private   frompatientStatus = new BehaviorSubject<any>(false);
  frompatientStatus$ = this.frompatientStatus.asObservable();
  private menusUpdateDataSource = new BehaviorSubject<any>(false);
  menudataupdating$ = this.menusUpdateDataSource.asObservable();

  private  drugallergiesDatasource = new BehaviorSubject<any>(false);
  drugAllergies$ = this.drugallergiesDatasource.asObservable();
   
  private ordersetmedications = new BehaviorSubject<any>('');
  medications$ = this.ordersetmedications.asObservable();
  
  private assessmenttrigerSource=new BehaviorSubject<any>(null);
  assessmenttriger$=this.assessmenttrigerSource.asObservable();

  private pastMedicalHistorySource=new BehaviorSubject<any>(null);
  pastMedicalHistory$=this.pastMedicalHistorySource.asObservable();

  private planTriggerSource=new BehaviorSubject<any>(false);
  planTriger$=this.planTriggerSource.asObservable();

  private getMedicationDetails  = new BehaviorSubject<any>(false);
  currentMedications$ = this.getMedicationDetails.asObservable()

  private addMedicationStatus = new BehaviorSubject<any>(true);
  addMedications$ = this.addMedicationStatus.asObservable();

  private saveMedicationData = new BehaviorSubject<any>('');
  saveMedData$ = this.saveMedicationData.asObservable()

  private nurseSelectedShiftTimings = new BehaviorSubject<any>('');
  saveTimings$ =  this.nurseSelectedShiftTimings.asObservable()

  
  private refreshIconsCounts = new BehaviorSubject<any>(false);
  refreshIconsCounts$ =  this.refreshIconsCounts.asObservable()

  private callCurrentMedication = new BehaviorSubject<any>(false);
  callCurrentMedication$ =  this.callCurrentMedication.asObservable()

  private PhysicianImage = new BehaviorSubject<any>(false);
  PhysicianImage$ =  this.PhysicianImage.asObservable();

  private medRecRefreshStatus = new BehaviorSubject<any>(false);
  medRecRefreshStatus$ =  this.medRecRefreshStatus.asObservable();

  private assignOrderExportStatus = new BehaviorSubject<any>(0);
  assignOrderExportStatus$ =  this.assignOrderExportStatus.asObservable();
  private getDateOfBirth = new BehaviorSubject<any>('')
  getDateOfBirth$ = this.getDateOfBirth.asObservable();

  private physicianUserInternalId = new BehaviorSubject<any>(null);
  physicianInternalId$ = this.physicianUserInternalId.asObservable();
  private refreshVitalData = new BehaviorSubject<any>(false);
  refreshVitalData$ =  this.refreshVitalData.asObservable()

  private vitalData = new BehaviorSubject<any>([]);
  vitalData$ =  this.vitalData.asObservable()

  private allergiesDataSorce = new BehaviorSubject<any>([]);
  allergiesDataList$ =  this.allergiesDataSorce.asObservable()


  private storeViewMedicationsData = new BehaviorSubject<any>(null);
  viewMedicationsData$ = this.storeViewMedicationsData.asObservable()

  private storeuserPageSettings = new BehaviorSubject<any>(null);
  storeuserPageSettings$ = this.storeuserPageSettings.asObservable()

  private storePrferencesData = new BehaviorSubject<any>(null);
  preferencesData$ = this.storePrferencesData.asObservable();
  private cpoeExpansionStatus= new BehaviorSubject<any>(null);
  cpoeExpansionStatus$= this.cpoeExpansionStatus.asObservable()
  // private storeMedicationFormData = new BehaviorSubject<any>(null);
  // medicationFormData$ = this.storeMedicationFormData.asObservable();
  private advancedSerachPatientData = new BehaviorSubject<any>(null);
  advancedSerachPatientData$= this.advancedSerachPatientData.asObservable();
  private  codeStatusData=new BehaviorSubject<any>(null);
  codeStatusData$=this.codeStatusData.asObservable();
private storeCodeStatusData=new BehaviorSubject<any>(null);
storeCodeStatusData$=this.storeCodeStatusData.asObservable();
private moveActiveProblem = new BehaviorSubject<any>(false)
moveActiveProblem$ =this.moveActiveProblem.asObservable();
private storeStaionid=new BehaviorSubject<any>(0);
storeStationIds$=this.storeStaionid.asObservable();
// private usernamepassword=new BehaviorSubject<any>(null)
// usernamepassword$=this.usernamepassword.asObservable()
// VR1 starts
private storePatientListData=new BehaviorSubject<any>(0);
storePatientListData$=this.storePatientListData.asObservable();
// VR1 ends
//devi
refreshSmokingData=new BehaviorSubject<any>(null);
refreshSmokingData$=this.refreshSmokingData.asObservable();

refreshMedications=new BehaviorSubject<any>(null);
refreshMedications$=this.refreshMedications.asObservable();

refreshAlcoholData=new BehaviorSubject<any>(null);
refreshAlcoholData$=this.refreshAlcoholData.asObservable();
refreshDrugData=new BehaviorSubject<any>(null);
refreshDrugData$=this.refreshDrugData.asObservable();
//devi end
SelectedErtemplates=[];
selectedNursetemplates=[];
private isNPI = new BehaviorSubject<any>(null);
isNPI$ = this.isNPI.asObservable();

private groupId = new BehaviorSubject<any>(null);
groupId$ = this.groupId.asObservable();

private timeOutSettings = new BehaviorSubject<any>(null);
timeOutSettings$ = this.timeOutSettings.asObservable();

private viewQuickOrders = new BehaviorSubject<any>(null);
viewQuickOrders$ = this.viewQuickOrders.asObservable();

private cRPatientSelection = new BehaviorSubject<any>(null);
cRPatientSelection$ = this.cRPatientSelection.asObservable();

refreshCodeStatus=new BehaviorSubject<any>(false);
refreshCodeStatus$=this.refreshCodeStatus.asObservable();

  constructor() { }

  //#region signals
  defaultColDefFieldsSig = signal<string[] | null>(null);
  set setDefaultColDefSig(colDefFields: string[]) {
    this.defaultColDefFieldsSig.set(colDefFields);
  }
  get defaultColDefFields(): string[] {
    return this.defaultColDefFieldsSig();
  }

  frequentlyUsedFlowsheetsSig = signal<FrequentlyUsedFlowsheet[] | null>(null);
  readonly frequentlyUsedFlowsheets = this.frequentlyUsedFlowsheetsSig.asReadonly();
  set setFrequentlyUsedFlowsheets(list: FrequentlyUsedFlowsheet[]) {
    this.frequentlyUsedFlowsheetsSig.set(list);
  }

  frequentlyUsedTemplateClickSig = signal<number | null>(null);
  readonly frequentlyUsedTemplateClick = this.frequentlyUsedTemplateClickSig.asReadonly();
  set setFrequentlyUsedTemplateClick(flowsheetId: number) {
    this.frequentlyUsedTemplateClickSig.set(flowsheetId);
  }
  //#endregion signals

  updatedmenuDatabysidebar(event){
    this.menusUpdateDataSource.next(event);
  }
  saveChangedOrdersetHeading(event){
    this.dataSource.next(event);
  }
  deleteItems(event){
    this.deleteDataArray.next(event);
  }
  deleteItem(event){
    this.deleteData.next(event);
  }
  getViewStaffUpdateStatus(value){
this.viewstaffUpdate.next(value);
  }
  getViewPhysicalResource(value){
    this.viewPhysicalResource.next(value)
  }
  getUserImage(object){
    this.PhysicianImage.next(object);
      }
  getViewphysicanUpdateStatus(value){
    this.viewphysicanUpdate.next(value);
      }
      getViewlocationUpdateStatus(value){
        this.viewlocationUpdate.next(value)
      }
  editProblemItem(event){
    //console.log.log('event',event)
    this.editdataSource.next(event);

  }
  sendExpansionStatus(value){
    this.cpoeExpansionStatus.next(value);
  }
  deleteProblemItem(event){
    //console.log.log('event',event)
    this.deletedataSource.next(event);

  }
  deleteProcedureItem(event){

this.procedureDeletedataSource.next(event)

  }
  addOrderset(event){
    //console.log.log('event',event)
    this.addOrdersetItem.next(event);

  }
  editClinicalTrialItem(event){
    //console.log.log('event',event)
    this.editClinicalTrialdataSource.next(event);

  }
  



  procedureEditItem(event){
    //console.log.log('event',event)
    this.procedureeditdataSource.next(event);

  }
  refreshMedicationsStatus(value){
    this.refreshMedications.next(value)
  }
getAdvancedpatientSearchData(data){
 this.advancedSerachPatientData.next(data) 
}
getCodeStatusData(data){
  this.codeStatusData.next(data)
}


  editProcedureItem(event){
    //console.log.log('editevent',event)
    this.editProceduredataSource.next(event);
  }
  addProcedureItem(event){
    //console.log.log('addevent',event)
    this.addProceduredataSource.next(event);
  }
  updateTemplateEditStatus(event){
    this.templateEditStatus.next(event);
  }
  fontSizeChange(event) {
    this.fontSizeBehaviour.next(event);
  }

  updateDraftStatus(event){
  this.draftSource.next(event);
}

erDashboardPatientData(event) {
  this.erDashboardPatientDataStatus.next(event);
}
gettemplateIdState(value,type){
  if(type==='ERTemplate'){
    let index=this.SelectedErtemplates.findIndex(ele=>ele.patientId===value.patientId);
    if(index!==-1){
      this.SelectedErtemplates[index].templateId=value.templateId;
      this.SelectedErtemplates[index].patDocNusTemplatesId=value.patDocNusTemplatesId;
      this.SelectedErtemplates[index].event=value.event
    }else {
      this.SelectedErtemplates=[...this.SelectedErtemplates,value]
    }
  
}else {
  let index=this.selectedNursetemplates.findIndex(ele=>ele.patientId===value.patientId);
  if(index!==-1){
    this.selectedNursetemplates[index].patDocNusTemplatesId=value?.patDocNusTemplatesId;
    this.selectedNursetemplates[index].templateId=value?.templateId;
    this.selectedNursetemplates[index].event=value.event
  }else {
    this.selectedNursetemplates=[...this.selectedNursetemplates,value]
  }
  // this.selectedNursetemplates=value;
}
  this.templateIdState.next(value)
}
updatepatDocTemplate(value,patientId,type){
  // //console.log.log(this.SelectedErtemplates)
  if(type==='ERTemplate'){
    let index=this.SelectedErtemplates.findIndex(ele=>ele.patientId===patientId);
    if(index!==-1){
      this.SelectedErtemplates[index].templateId=0;
     
      this.SelectedErtemplates[index].event.patDocNusTemplatesId=value;
      this.SelectedErtemplates[index].patDocNusTemplatesId=this.SelectedErtemplates[index].event.patDocNusTemplatesId;
      // this.SelectedErtemplates[index].event.node.data.element.patDocNusTemplatesId=this.SelectedErtemplates[index].event.patDocNusTemplatesId;
      // this.SelectedErtemplates[index].event.node.data.element.tempViewMode='Draft';
    }else {
      this.SelectedErtemplates=[...this.SelectedErtemplates]
    }
  //console.log.log(this.SelectedErtemplates)
}else {
  let index=this.selectedNursetemplates.findIndex(ele=>ele.patientId===patientId);
  if(index!==-1){
    this.selectedNursetemplates[index].templateId=0;
    this.selectedNursetemplates[index].event.patDocNusTemplatesId=value;
    this.selectedNursetemplates[index].patDocNusTemplatesId=this.selectedNursetemplates[index].event.patDocNusTemplatesId;
    // this.selectedNursetemplates[index].event.node.data.element.patDocNusTemplatesId=this.selectedNursetemplates[index].event.patDocNusTemplatesId;
    // this.selectedNursetemplates[index].event.node.data.element.tempViewMode='Draft';
 
    
  }else {
    this.selectedNursetemplates=[...this.selectedNursetemplates]
  }
  // this.selectedNursetemplates=value;
}
  this.templateIdState.next(value)
}
navigatetoOtherRoute(value){
  this.navigateToOther.next(value) 
}
getTemplateIdFormService(type){
  if(type==='ERTemplate'){
   return this.SelectedErtemplates;
  }else {
   return this.selectedNursetemplates;
  }
   
 
}

getPhePatientTemplateDraft(pheData: any[]): void {
  this.phePatientTemplateDraft.next(pheData);
}
 getfrompatientStatus(value){
   this.frompatientStatus.next(value)
 }
 getdrugallergiesDatasource(value){
this.drugallergiesDatasource.next(value);
 }
 getMedications(value){
   //console.log.log(value);
   
   this.ordersetmedications.next(value)
 }
 triggerAssessemnt(value){
  this.assessmenttrigerSource.next(value);
 }
 triggerPAstMedicalHistory(value){
  this.pastMedicalHistorySource.next(value);
 }
 ordersetTriggerPlan(){
this.planTriggerSource.next(true);
 }
 getCurrentMedications(value){
  this.getMedicationDetails.next(value)
 }
 updateMedicationStatus(event){
  this.addMedicationStatus.next(event);
}
updateMedicationData(event){
  this.saveMedicationData.next(event)
}
sendSelectedTimings(data){
  //console.log.log(data)
 this.nurseSelectedShiftTimings.next(data)
}
getIconCountstatus(value){
  this.refreshIconsCounts.next(value)
}
callCurrentMedications(value){
  this.callCurrentMedication.next(value)
}
getMoveActiveProblem(value){
  this.moveActiveProblem.next(value)
}
getVitalSignData(value){
  this.refreshVitalData.next(value)
}
getvitalData(data){
  // console.log(data);
  this.vitalData.next(data);
}
getAssignOrderExportStatus(value){
  this.assignOrderExportStatus.next(value);
}
getDobFormDemographic(data){
this.getDateOfBirth.next(data);
}
getUserInternalId(physicianUserInternalId){ //y1 
  // console.log(physicianUserInternalId);
  this.physicianUserInternalId.next(physicianUserInternalId)
}

  private selectedCPOETab = new BehaviorSubject<string>('');
  selectedCPOETab$ = this.selectedCPOETab.asObservable();
  getselectedCPOETab(value: string) {
    this.selectedCPOETab.next(value)
  }
saveViewMedicationData(data){
 this.storeViewMedicationsData.next(data)
}
getPreferences(data){
  this.storePrferencesData.next(data)
}
// saveMedicationFormData(data){
//   this.storeMedicationFormData.next(data)
// }

  private _pharmacyLoadingIntervalTime = new BehaviorSubject<number>(null);
  pharmacyLoadingIntervalTime$ = this._pharmacyLoadingIntervalTime.asObservable();
  updatePharmacyLoadingIntervalTime(intervalTime: number): void {
    this._pharmacyLoadingIntervalTime.next(intervalTime);
  }
  getstoreCodeStatusData(data){
    this.storeCodeStatusData.next(data)
  }
  getNPIStatus(data){
    this.isNPI.next(data)
  }
  storePatientId(value){
    this.selectedPatient.next(value);
  }
  storeStationId(value){
    this.storeStaionid.next(value);
  }
  // getUsernamePassword(value){
  //   // console.log(value)
  //   this.usernamepassword.next(value);
  // }
  // VR1 starts
  getPatientList(value) {
    this.storePatientListData.next(value)
  }
  // VR1 ends
  refreshSmokingDataStatus(val){
    this.refreshSmokingData.next(val)
  }
  refreshAlcoholDataStatus(val){
    this.refreshAlcoholData.next(val)
  }
  refreshDrugDataStatus(val){
    this.refreshDrugData.next(val)
  }

  //#region Store ShiftId based on Nursing station.
  private _nursingStationShiftId = new BehaviorSubject<string>(null);
  nursingstationShiftId$ = this._nursingStationShiftId.asObservable();
  setNursingStationShiftId(shiftIds: string): void {
    this._nursingStationShiftId.next(shiftIds);
  }
  groupIdData(event){
    //console.log.log('event',event)
    this.groupId.next(event);

  }
  timeOutSettingsData(event){
    this.timeOutSettings.next(event)
  }
  viewQuickOrdersData(event){
    this.viewQuickOrders.next(event)
  }
  downloadPdfAudio(event){
    this.pdfAudioDoc.next(event)
  }
  getUpdatedMedicationData(event){
    this.medicationData.next(event)
  }
  groupChatUser(event){
    this.chatGroupUserData.next(event)
  }
  getUpdateAllergiesData(event){
    this.allergiesData.next(event)
  }
  getUpdateProblemsData(event){
    this.problemsData.next(event)
  }

  getSelectedAllergiesArrayLength(event){
    this.allergiesLength.next(event)
  }
getSelectedMedicationsArrayLength(event){
  this.medicationsLength.next(event)
}

getSelectedProblemsArrayLength(event){
  this.problemsLength.next(event)
}
isMonthValid(event){
  this.monthValid.next(event)
}
isYearValid(event){
  this.yearValid.next(event)
}
isExpiredMedication(event){
  this.isExpiredMed.next(event)
}
getLogOutSettingsData(event){
  this.logOutSettingsData.next(event)
}
clearReconciledData(event){
  this.clearReconciled.next(event)
}
clearReconciledProblemsData(event){
  this.clearReconciledProblems.next(event)
}

clearReconciledAllergiesData(event){
  this.clearReconciledAllergies.next(event)
}
  //#endregion Store ShiftId based on Nursing station.

  storeAllergiesData(data){
    this.allergiesDataSorce.next(data);
  }
  
  getDateOfDeathFormDemographic(data){
    this.patientDateOfDeath.next(null);
    }
    storecRPatientSelection(value){
      this.cRPatientSelection.next(value)
    }
    updateMedRecStatus(value){
      this.medRecRefreshStatus.next(value)
    }
 private patientDateOfDeath = new BehaviorSubject<any>('')
    patientDateOfDeath$ = this.patientDateOfDeath.asObservable();
getCodestatusRefresh(value){
  this.refreshCodeStatus.next(value)
}
storevitalsUnitsStatus(value){
  this.vitalsUnitsStatus.next(value)
}
storeCheckboxRadioAlignEvent(value){
  this.storeCheckboxRadioAlign.next(value);
}
storeUserPageSettingValue(value){
  this.storeuserPageSettings.next(value);
}
updateErDashboardRowData(value){
  this.updateErDRowDataSource.next(value);
}
updategridSelection(value){
  this.gridselectionSource.next(value);
}
attendingPhyicianId=new BehaviorSubject<any>('')
attendingPhyicianId$ = this.attendingPhyicianId.asObservable();
sePhysicianData(value){
  this.attendingPhyicianId.next(value);
}
}
